export default {
  SMS: "sms",
  MAIL: "mail",
  NET: "net",
  IOT: "iot",
  LX_IOT: "lx_iot"
};
